import { FLOW } from 'redux/actions/Types';
import {
  all,
  takeLatest,
} from 'redux-saga/effects';
import { createConnectNodesWithEdge } from 'redux/saga/FlowsSaga/createConnectNodesWithEdge';
import { createQuestionNode } from 'redux/saga/FlowsSaga/createQuestionNode';
import { deleteQuestionNode } from 'redux/saga/FlowsSaga/deleteQuestionNode';
import { fetchFlowDetails } from 'redux/saga/FlowsSaga/fetchFlowDetails';
import { fetchFlowNodeCompleteDetails } from 'redux/saga/FlowsSaga/fetchFlowNodeCompleteDetails';
import { fetchFlowNodesCompleteDetails } from 'redux/saga/FlowsSaga/fetchFlowNodesCompleteDetails';


export default function* root() {
  yield all([
    takeLatest(FLOW.CREATE_NODE, createQuestionNode),
    takeLatest(FLOW.CONNECT_NODES_WITH_EDGE, createConnectNodesWithEdge),
    takeLatest(FLOW.DELETE_FLOW_NODE, deleteQuestionNode),
    takeLatest(FLOW.FETCH_FLOW_DETAILS, fetchFlowDetails),
    // fetch single node details
    takeLatest(FLOW.FETCH_FLOW_NODE_COMPLETE_DETAILS, fetchFlowNodeCompleteDetails),
    // fetch all nodes details
    takeLatest(FLOW.FETCH_FLOW_NODES_COMPLETE_DETAILS, fetchFlowNodesCompleteDetails),
  ]);
}
